'use client';

import dynamic from 'next/dynamic';
import PublicPageLayout from '@/components/layouts/PublicPageLayout';
import { copy } from '@/data/copy';
import { MultiStepIndicatorProvider } from '@/components/formElements/MultiStepIndicatorContext';
import MultiStepIndicator from '@/components/formElements/MultiStepIndicator';

const MentorSignUpFormMultiStep = dynamic(
  () => import('@/components/forms/MentorSignUpFormMultiStep'),
  { ssr: false }
);

export default function MentorSignUp() {
  return (
    <MultiStepIndicatorProvider>
      <PublicPageLayout
        CTAContent={
          <>
            <h1 className="text-bodydark1">
              {copy.pages.signup.ctaContent.title}
            </h1>
            <p className="text-bodydark1 mt-8">
              {copy.common.publicRoute.whoWeAre}
            </p>

            <MultiStepIndicator />
          </>
        }
      >
        <div className="flex flex-col w-full py-5 md:py-10">
          <MentorSignUpFormMultiStep
            title={
              <h2 className="text-2xl font-bold text-black dark:text-white sm:text-title-xl2">
                {copy.pages.signup.mentor.title}
              </h2>
            }
          />
        </div>
      </PublicPageLayout>
    </MultiStepIndicatorProvider>
  );
}
